import { render, staticRenderFns } from "./PayzenPaymentForm.vue?vue&type=template&id=2486b87a&scoped=true"
import script from "./PayzenPaymentForm.vue?vue&type=script&lang=js"
export * from "./PayzenPaymentForm.vue?vue&type=script&lang=js"
import style0 from "./PayzenPaymentForm.vue?vue&type=style&index=0&id=2486b87a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2486b87a",
  null
  
)

export default component.exports